/* eslint-disable */
<template>
  <div>

    <div class="strate_box">
      <div class="title_box">
        消息类型：
      </div>
      <div>
        <el-radio-group v-model="obr.messytie" @change="messagechangemessytie">
          <el-radio v-for="items,indexs in meassagearrgo" :key="indexs" :label="items.key">{{ items.value }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div v-show="obr.messytie === 1">
      <div class="strate_box">
        <div>
          选择的消息：
        </div>
        <div>
          {{ messagename }}
        </div>
      </div>
      <div class="search_box">
        <el-input v-model="objr.title" clearable style="width:200px;" placeholder="请输入标题" />
        <el-input v-model="objr.customer_message_no" clearable style="width:200px;" placeholder="请输入编号" />
        <el-select v-model="objr.msg_type" placeholder="请选择客服类型">
          <el-option
            v-for="itemr in selectoptionse"
            :key="itemr.key"
            :label="itemr.value"
            :value="itemr.key"
          />
        </el-select>
        <el-select v-model="objr.onlyMe" placeholder="请选择">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="searchclickr">搜索</el-button>
      <el-button type="primary" @click="rechargeclickr">重置</el-button>
      <el-table
        ref="table"
        :key="refreshKey"
        :data="publicAdvertListr"
        style="width: 100%"
      >
        <!-- <el-table-column
          label="选项"
          width="100"
        >
          <template slot-scope="scope">
            <input
              v-model="scope.row.checkboxFlag"
              type="checkbox"
              @click="handleChangeSelectone(scope.$index, scope.row)"
            >
            {{ scope.row.$index }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="customer_message_no"
          label="编号"
          align="center"
          width="250"
        />
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        />
        <el-table-column
          prop="msg_type_str"
          label="类型"
          align="center"
        />
        <el-table-column
          prop="platform_name"
          label="所属平台"
          align="center"
        />
        <el-table-column
          label="操作"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="timingpreview(scope.row,1)">预览</el-button>
            <el-button type="primary" size="mini" @click="chooseres(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        ref="paginationbox"
        :total="newtotalr"
        @size-change="fetchPageSizer($event)"
        @current-change="fetchCurrentPager"
      />
    </div>
    <div v-show="obr.messytie === 2">
      <div class="strate_box">
        <div>
          选择的消息：
        </div>
        <div>
          {{ templatename }}
        </div>
      </div>
      <el-select v-model="objrr.onlyMe" placeholder="请选择">
        <el-option
          v-for="item in accountarrlist"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="searchar">搜索</el-button>
      <el-table
        :key="refreshKeyr"
        :data="templatedata"
        style="width: 100%"
      >
        <!-- <el-table-column

          label="选项"
          width="100"
        >
          <template slot-scope="scope">
            <input
              v-model="scope.row.checkboxFlag"
              type="checkbox"
              @click="handleChangeSelectonewe(scope.$index, scope.row)"
            >
            {{ scope.row.$index }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="templateMessageAdminNo"
          label="编号"
          align="center"
        />
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        />
        <el-table-column
          prop="platformName"
          label="所属平台"
          align="center"
        />
        <el-table-column
          label="操作"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="timingpreview(scope.row,2)">预览</el-button>
            <el-button type="primary" size="mini" @click="chooseress(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="templatetotalre"
        @size-change="fetchPageSizeone"
        @current-change="fetchCurrentPageone"
      />
    </div>

    <div v-show="obr.messytie === 3">
      <div class="search_box">
        <div style="margin-right:10px">
          <el-input v-model="pageIfon.title" placeholder="请输入标题" style="margin-right: 10px;" />
        </div>
        <div style="margin-right: 10px;">
          <el-select v-model="pageIfon.onlyMe" placeholder="请选择">
            <el-option
              v-for="item in accountarrw"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button>
        </div>
      </div>
      <div class="allboxwe">
        <div v-for="item,index in imgarrs" :key="index" class="dssakse" @click="choose(item)">
          <div v-if="item.type ==1 && item.articles.length>5" class="tewr_aerbox">
            <i class="el-icon-bottom" />
          </div>
          <div ref="contentData" class="daswrw" style="margin-right: 15px;margin-bottom:15px;max-height:410px;overflow-y: scroll;">
            <div class="tewr_box" :style="{ paddingBottom: item.articles.length > 1 ? '5px' : '0px' }">
              <div v-for="items,idx in item.articles" :key="idx">
                <div v-if="item.type == 1">
                  <div v-if="idx == 0" class="onebox">
                    <img class="onebox_img" :src="items.srv" alt="" :style="{ borderRadius: item.articles.length > 1 ? '6px 6px 0px 0px' : '6px' }">
                    <div class="onebox_imgr">{{ items.title }}</div>
                    <el-tag class="deopviewr" size="small">
                      <div class="tiower">
                        <div :title="item.title" class="tiotext">{{ item.title }}</div>
                        <div>（{{ item.platform_name }}）</div>
                      </div>
                    </el-tag>
                  </div>
                  <div v-else>
                    <div class="itemwew">
                      <div class="itemwew_title">
                        {{ items.title }}
                      </div>
                      <img class="onebox_srv" :src="items.srv" alt="">
                    </div>
                    <div class="line" />
                  </div>

                </div>
                <div v-else>
                  <div class="oneboxrr">
                    <div v-html="srt(item.articles[0].content).replace(/\n/g,'<br>')" />
                    <el-tag class="deopviewr" size="small">
                      <div class="tiower">
                        <div :title="item.title" class="tiotext">{{ item.title }}</div>
                        <div>（{{ item.platform_name }}）</div>
                      </div>
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <pagination-right
        :current-page="pageIfon.page"
        :total="totalrw"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <!-- <div>
      <el-button size="mini" type="primary" @click="goclick">确定</el-button>
    </div> -->
    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <PreviewDialog ref="timepreview" />
    </el-dialog>
  </div>
</template>

<script>
import { customercreatlist, /* templatelist,*/ templateadminlist, accountlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import PreviewDialog from '../../timedPush/components/PreviewDialog'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight,
    PreviewDialog
  },
  mixins: [convertToHump],
  props: {
    selectoptionse: {
      type: Array,
      default: () => ([])
    },
    oneselectarr: {
      type: Object,
      default: () => ({})
    },
    twoselectarr: {
      type: Object,
      default: () => ({})
    }

  },
  data() {
    return {
      indexr: null,
      priwdialogVisible: false,
      obr: {

        messytie: 1
      },
      kefuid: null,
      mobanid: null,
      temrascalkeywords: null,

      messagename: null,
      // 消息类型数组
      meassagearrgo: [
        {
          key: 1,
          value: '客服消息'
        },
        {
          key: 2,
          value: '模板消息'
        },
        {
          key: 3,
          value: '群发消息'
        }
      ],
      accountarr: [{
        value: 1,
        label: '查看组内客服消息'
      }, {
        value: 2,
        label: '我关联的客服消息'
      }],
      accountarrlist: [{
        value: 1,
        label: '查看组内模板消息'
      }, {
        value: 2,
        label: '我关联的模板消息'
      }],
      publicAdvertListr: [],
      refreshKey: 0,
      newtotalr: null,
      objr: {
        title: null,
        customer_message_no: null,
        msg_type: null,
        page: 1,
        pageSize: 10,
        platform_id: null,
        onlyMe: 2
      },
      templatename: null,
      refreshKeyr: 0,
      templatedata: [],
      templatetotalre: null,
      objrr: {
        page: 1,
        pageSize: 10,
        platform_id: null,
        onlyMe: 2
      },

      imgarrs: [],
      totalrw: null,
      pageIfon: {
        page: 1,
        pageSize: 10,
        platform_id: null,
        title: null,
        onlyMe: 2
      },
      accountarrw: [{
        value: 1,
        label: '查看组内模板'
      }, {
        value: 2,
        label: '我创建的模板'
      }]

    }
  },
  watch: {
    oneselectarr: function() {
      console.log('oneselectarr1', this.oneselectarr)
      this.mentwoarr(this.oneselectarr)
    },

    twoselectarr: function() {
      console.log('twoselectarr1', this.twoselectarr)
      this.temparr(this.twoselectarr)
    },
    deep: true

  },
  created() {
    this.mentwoarr(this.oneselectarr)
    this.temparr(this.twoselectarr)
    // this.menuList()
    // this.gettemplatelist()
  },
  mounted() {
    window.aa = this
  },
  methods: {
    // 获取客服消息
    menuList() {
      customercreatlist(this.objr).then(res => {
        this.publicAdvertListr = res.data.list
        this.publicAdvertListr.forEach(item => {
          item.checkboxFlag = false
          if (item.customer_message_no === this.kefuid) {
            item.checkboxFlag = true
          }
        })
        this.newtotalr = res.data.total
      })
    },
    // 获取模板消息 接口
    async gettemplatelist() {
      const data = await templateadminlist(this.objrr)
      this.templatedata = this.convertToHump(data.data.list)
      this.templatedata.forEach(item => {
        item.checkboxFlag = false
        if (item.templateMessageAdminNo === this.mobanid) {
          item.checkboxFlag = true
        }
      })
      this.templatetotalre = data.data.total

      console.log('模板列表', data)
    },

    mentwoarr(res) {
      this.publicAdvertListr = res.list
      this.publicAdvertListr.forEach(item => {
        item.checkboxFlag = false
        if (item.customer_message_no === this.kefuid) {
          item.checkboxFlag = true
        }
      })
      this.newtotalr = res.total
    },
    temparr(res) {
      this.templatedata = res.list
      this.templatedata.forEach(item => {
        item.checkboxFlag = false
        if (item.templateMessageAdminNo === this.mobanid) {
          item.checkboxFlag = true
        }
      })
      this.templatetotalre = res.total
    },
    messagechangemessytie(val) {
      // if (val === 1) {
      //   console.log('我是客服', val)
      //   this.$emit('gione', this.obr, this.kefuid)
      // }
      // if (val === 2) {
      //   console.log('我是模板', val)
      //   this.$emit('gione', this.obr, this.mobanid)
      // }
    },
    goclick() {
      if (this.obr.messytie === 1) {
        // console.log('我是客服', val)
        console.log('this.obr, this.kefuid, this.messagename, this.indexr', this.obr, this.kefuid, this.messagename, this.indexr)
        this.$emit('gione', this.obr, this.kefuid, this.messagename, this.indexr)
      }
      if (this.obr.messytie === 2) {
        // console.log('我是模板', val)
        this.$emit('gione', this.obr, this.mobanid, this.templatename, this.indexr)
      }
    },
    chooseres(item) {
      console.log('item', item)
      this.$emit('gione', this.obr, item.customer_message_no, item.title, this.indexr)
    },
    chooseress(item) {
      console.log('itemrrr', item)
      this.$emit('gione', this.obr, item.templateMessageAdminNo, item.title, this.indexr)
    },
    choose(item) {
      console.log('itemrrr', item, this.obr)
      this.$emit('gione', this.obr, item.id, item.title, this.indexr, item.platform_name)
    },
    send(item, index, id) {
      this.indexr = index
      this.objr.platform_id = id
      this.objrr.platform_id = id
      this.pageIfon.platform_id = id
      this.menuList()
      this.gettemplatelist()
      this.acounewlist()
      if (item.relationType === null) {
        this.obr.messytie = 1
      } else {
        this.obr.messytie = item.relationType
      }

      if (item.relationType === 1) {
        this.messagename = item.relationmessage
        this.kefuid = item.relationId
        this.publicAdvertListr.forEach((items) => {
          if (items.customer_message_no === item.relationId) {
            items.checkboxFlag = true
            this.refreshKey = Math.random()
          }
        })
        console.log('publicAdvertListr', this.publicAdvertListr)
      }
      if (item.relationType === 2) {
        this.templatename = item.relationmessage
        this.mobanid = item.relationId
        this.templatedata.forEach((items) => {
          if (items.templateMessageAdminNo === item.relationId) {
            items.checkboxFlag = true
            this.refreshKeyr = Math.random()
          }
        })
      }
      console.log('item', item)
    },
    searchclickr() {
      this.menuList()
    },
    rechargeclickr() {
      this.objr = {
        title: null,
        customer_message_no: null,
        msg_type: null,
        page: 1,
        pageSize: 10,
        platform_id: this.objr.platform_id,
        onlyMe: 2
      }
      this.menuList()
    },
    handleChangeSelectone(index) {
      console.log(this.publicAdvertListr[index])
      if (!this.publicAdvertListr[index].checkboxFlag) {
        this.messagename = this.publicAdvertListr[index].title
        this.kefuid = this.publicAdvertListr[index].customer_message_no
        // this.$emit('gione', this.obr, this.kefuid)
      } else {
        // this.selectData = null
      }
      this.publicAdvertListr.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvertListr[index].checkboxFlag = true
      this.refreshKey = Math.random()
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },

    fetchPageSizeone(e) {
      this.objrr.pageSize = e
      this.gettemplatelist()
    },
    fetchCurrentPageone(e) {
      this.objrr.page = e
      this.gettemplatelist()
    },
    // checkbox模板单选
    handleChangeSelectonewe(index) {
      console.log('this.templatedata[index]', this.templatedata[index])
      if (!this.templatedata[index].checkboxFlag) {
        this.templatename = this.templatedata[index].title
        this.mobanid = this.templatedata[index].templateMessageAdminNo
        // this.$emit('gione', this.obr, this.mobanid)
      } else {
        // this.selectData = null
      }
      this.templatedata.forEach(item => {
        item.checkboxFlag = false
      })
      this.templatedata[index].checkboxFlag = true
      this.refreshKeyr = Math.random()
    },
    twopsend() {
      this.publicAdvertListr.forEach((items) => {
        items.checkboxFlag = false
        this.refreshKey = Math.random()
        this.$nextTick(function() {
          if (items.customer_message_no === this.kefuid) {
            items.checkboxFlag = true
            this.refreshKey = Math.random()
          }
        })
      })
      this.templatedata.forEach((items) => {
        items.checkboxFlag = false
        this.refreshKeyr = Math.random()
        this.$nextTick(function() {
          if (items.templateMessageAdminNo === this.mobanid) {
            items.checkboxFlag = true
            this.refreshKeyr = Math.random()
          }
        })
      })
    },
    // 客服预览
    timingpreview(val, id) {
      console.log('val', val)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(val, id)
      }, 100)
    },
    searchar() {
      this.objrr.page = 1
      this.gettemplatelist()
    },

    async acounewlist() {
      const data = await accountlist(this.pageIfon)
      this.imgarrs = data.data.list
      this.totalrw = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.acounewlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.acounewlist()
    },
    search() {
      this.pageIfon.page = 1
      this.acounewlist()
    },
    reast() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.title = null
      this.pageIfon.onlyMe = 2
      this.acounewlist()
    },
    srt(str) {
      return str.replace(/<a(.*?)>/g, '<a$1 target="_blank" rel="noopener noreferrer">')
    }

  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.strate_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  div{
    flex-shrink: 0;
  }
   span{
      margin-left: 10px;
   }
}
.copy_box{
  margin-left: 10px;
}

.boxr{
  padding: 20px;
}
.search_boxr{
  justify-content: space-between;
}
.search_box{
  display: flex;
  margin: 10px 0px;
}
.tewr_box{
  width: 300px;
  /* height: 500px; */
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  margin-bottom: 10px;
}
.dssakse{
  position: relative;
  cursor: pointer;
}
.tewr_aerbox{
  position: absolute;
    bottom: 30px;
    left: 134px;
    z-index: 999;
    cursor: pointer;
}
.onebox{
  width: 100%;
  height: 130px;
  /* border: 1px solid red; */
  position: relative;
}
.oneboxrr{
  width: 100%;
  /* height: 130px; */
  /* border: 1px solid red; */
  position: relative;
  text-align: center;
  padding: 50px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.onebox_img{
  width: 298px;
  height: 130px;
  /* border-radius: 6px 6px 0px 0px; */
}
.onebox_imgr{
  position: absolute;
  bottom: 10px;
  left: 5px;
  color: white;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 270px;
  font-size: 15px;
}
.onebox_srv{
  height: 50px;
  width: 50px;
}
.itemwew_title{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 216px;
  font-size: 13px;
  height: 36px;
}
.itemwew{
  display: flex;
  padding: 0px 10px;
  align-items: center;
  margin-top: 10px;
  justify-content: space-around;
}
.line{
  width: 200px;
  height: 1px;
  background: #e5e5e5;
  margin-left: 10px;
  margin-top: 5px;
}
.allboxwe{
  display: flex;
  flex-wrap: wrap;
  max-height: 650px;
  overflow: auto;
}
.el-dropdown-link {
    cursor: pointer;
    color: white;
  }
  .el-dropdown-linkr{
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .deopview{
position: absolute;
top: 7px;
    right: 10px;
  }
  .deopviewr{
    position: absolute;
top: 3px;
    left: 5px;
  }
  .tiower{
    display: flex;
    align-items: center;
  }
  .tiotext{
    max-width: 140px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .daswrw{
    position: relative;
  }
  ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: rgba(0,0,0,.2);
        display: none;
    }

    /*定义滚动条轨道
 内阴影+圆角*/
    ::-webkit-scrollbar-track
    {
        -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.3);
        border-radius:10px;
        background-color:#F5F5F5;
    }
    /*定义滑块
     内阴影+圆角*/
    ::-webkit-scrollbar-thumb
    {
        border-radius:10px;
        -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);
        background-color: #b3b3b3;
    }
</style>
